<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <ul class="sidebar-menu" data-widget="tree">
        <!--<va-slide-item
          key="home"
          type="item"
          icon="jarvis-icon-chart"
          :name="$t('menu.home')"
          :router="{ name: 'home' }"
        ></va-slide-item>-->
        <va-slide-item
          key="matters"
          type="item"
          icon="jarvis-icon-briefcase"
          :name="$t('menu.matters')"
          :router="{ name: 'matters' }"
        ></va-slide-item>
        <va-slide-item
          v-if="LawFirmDriveModule"
          key="documents"
          type="item"
          icon="jarvis-icon-drive"
          :name="$t('menu.documents')"
          :router="{ name: 'documents' }"
        ></va-slide-item>
        <!--<va-slide-item
          key="invoices"
          type="item"
          icon="jarvis-icon-note"
          :name="$t('menu.invoices')"
          :router="{ name: 'invoices' }"
        ></va-slide-item>-->
      </ul>
    </section>
  </aside>
</template>

<script>
// noinspection NpmUsedModulesInstalled
import VASlideItem from 'va/components/VASlideItem'

export default {
  data () {
    return {
      LawFirmDriveModule: false
    }
  },
  components: {
    'va-slide-item': VASlideItem
  },
  methods: {
    hasModule () {
      if (this.$store.getters.currentLawFirm.hasDriveModule) {
        this.LawFirmDriveModule = true
      }
    }
  },
  created () {
    this.hasModule()
  }
}
</script>

<style>
  .sidebar-menu li span:nth-child(2) {
    margin-left: 20px;
  }
</style>
